import React, { useEffect, useState } from 'react';
import {
  getArtisanProductsAction,
  getArtisanProductsPictures
} from '../../../modules/artisanProducts/Actions';
import {
  artisanProductsSelector,
  artisanProductsIsLoadingSelector,
  searchValueSelector,
  artisanProductsCountSelector
} from '../../../modules/artisanProducts/Selectors';
import { connect } from 'react-redux';
import List from '../../../components/Lists/List';
import ListItem from '../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import getLangData from '../../../utils/getLangData';
import { getArtisansAction } from '../../../modules/artisans/Actions';
import {
  artisansAsLabelAndValueSelector,
  artisansIsLoadingSelector
} from '../../../modules/artisans/Selectors';
import { SearchableSelect } from '../../../components/form';
import { FormGroup } from '../../../components/form/';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { Button } from 'react-bootstrap';

const ArtisanProductsList = props => {
  const {
    artisanProducts,
    artisanProductsIsLoading,
    getArtisanProducts,
    searchValue,
    artisanProductsCount,
    getArtisanProductsPictures,
    artisans,
    getArtisans,
    artisansIsLoading,
    isLoading
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    getArtisanProducts({ size, offset, searchTerm: searchValue });
  }, [getArtisanProducts, searchValue]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (artisanProducts.length >= artisanProductsCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getArtisanProducts({
      size,
      offset: artisanProducts.length,
      searchTerm: searchValue
    });
  };

  //
  const dataLength =
    artisanProducts.length <= artisanProductsCount
      ? artisanProducts.length
      : artisanProductsCount;

  const schema = () =>
    Yup.object().shape({
      artisanID: Yup.string()
        .default('')
        .required(getLangData().fields.required) // done
      /* productImages : Yup.array.of() */
    });
  return (
    <>
      <Formik
        validationSchema={schema()}
        enableReinitialize
        initialValues={schema().cast()}
        onSubmit={async values => {
          const artisanID = values.artisanID._id;
          console.log(artisanID, 'artisanID');
          getArtisanProducts({
            size: 100,
            offset: 0,
            searchTerm: searchValue,
            filterArtisan: artisanID
          });
        }}
      >
        {({ values, handleSubmit, setFieldValue, errors }) => (
          <form onSubmit={handleSubmit}>
            <SearchableSelect
              name='artisanID'
              label={getLangData().general_words.artisan_products}
              getItems={getArtisans}
              options={artisans}
              isLoading={artisansIsLoading}
              getLabel={getLangData().fields.busience_name}
              getOptionValue={values.artisanID}
              optionLabel={option =>
                `${getLangData().fields.name} : ${option.businessName} - ${getLangData().fields.email
                } : ${option.contactPersonEmail}`
              }
            // value={values.artisanID}
            />
            <Button type='submit'>{getLangData().general_words.submit}</Button>
            <Button
              className='mx-2'
              onClick={() => {
                getArtisanProducts({
                  size,
                  offset: artisanProducts.length,
                  searchTerm: searchValue
                });
              }}
            >
              {getLangData().fields.show_all}
            </Button>
          </form>
        )}
      </Formik>
      <InfiniteScroll
        next={fetchMore}
        hasMore={hasMore}
        dataLength={dataLength}
        style={{ overflow: 'hidden' }}
      >
        <div className='table row block--container my-5'>
          <List
            isLoading={artisanProductsIsLoading}
            items={artisanProducts}
            header={{ items: [getLangData().fields.name], actions: ['Edit'] }}
          >
            <table className='table'>
              <tbody>
                {artisanProducts.map(({ name, _id, email }) => (
                  <ListItem
                    key={_id}
                    name={name}
                    description={email}
                    editLink={`/artisan-products/${_id}`}
                  /* onDelete={() => deleteTag(_id)} */
                  />
                ))}
              </tbody>
            </table>
          </List>
        </div>
      </InfiniteScroll>
    </>
  );
};

const mapStateToProps = state => ({
  artisanProducts: artisanProductsSelector(state),
  artisans: artisansAsLabelAndValueSelector(state),
  artisanProductsIsLoading: artisanProductsIsLoadingSelector(state),
  artisanProductsCount: artisanProductsCountSelector(state),
  searchValue: searchValueSelector(state),
  artisansIsLoading: artisansIsLoadingSelector(state),
  isLoading: artisanProductsIsLoadingSelector(state)
});

export default connect(mapStateToProps, {
  getArtisanProducts: getArtisanProductsAction,
  getArtisanProductsPictures: getArtisanProductsPictures,
  getArtisans: getArtisansAction
})(ArtisanProductsList);
